import React, { ChangeEventHandler } from 'react';
import { Form } from 'react-bootstrap';

/**
 * OtherAppointmentFormコンポーネント用のPropsです。
 * @interface OtherAppointmentFormProps
 */
interface OtherAppointmentFormProps {

  /**
   * 索引
   * @type {number}
   * @memberof OtherAppointmentFormProps
   */
  index: number;

  /**
   * その他の委任事項
   * @type {string}
   * @memberof OtherAppointmentFormProps
   */
  otherAppointment: string;

  /**
   * その他の委任事項を設定する関数
   * @memberof OtherAppointmentFormProps
   */
  onChange: (index: number, updatedValue: string) => void;
}

/**
 * その他の委任事項フォームのコンポーネントです。
 * @param {number} props.index - 索引
 * @param {string} props.otherAppointment - その他の委任事項
 * @param {function} props.onChange - その他の委任事項が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - その他の委任事項フォームのJSX要素
 */
const OtherAppointmentForm: React.FC<OtherAppointmentFormProps> = ({index, otherAppointment, onChange}) => {

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力されたその他の委任事項を引数にonChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange(index, event.target.value);
  };

  return (
    <Form.Group>
      <Form.Control
        type="text"
        value={otherAppointment}
        onChange={handleChange}
        placeholder="その他の委任事項を入力してください。"
      />
    </Form.Group>
  );
}

export default OtherAppointmentForm;